import { BILLING_CYCLE, BillingCycleEnum } from '@/common/constants';
import { getBasePlanInfo } from '@/common/product';
import _ from 'lodash';
import { logger } from '@/utils/log';
import { pageConfig } from '@/common/service/page-config';
import { $context } from "@/global-install";

// check ze/zs plan list should align base plan billing cycle
export const filterEventPlansForAdd2Cart = (planList, boughtPlans, needRemoveAnnualPlan = true) => {
  const addType = pageConfig?.editConfig?.planType;

  const { plans: basePlans, planType: boughtBasePlanType } = getBasePlanInfo(boughtPlans);
  const currentBasePlan = _.get(basePlans, [0], {});
  const currentPlanList = _.filter(planList, (p) => p.type === addType);
  const dependBasePlanTypeList = _.get(currentPlanList, [0, 'dependBasePlanTypeList'], []);
  const hasBoughtDepBasePlan = dependBasePlanTypeList.length && _.includes(dependBasePlanTypeList, boughtBasePlanType);

  if (hasBoughtDepBasePlan && (currentBasePlan.cycleValue < BillingCycleEnum[BILLING_CYCLE.ANNUAL]) && !currentBasePlan.isFreeTrial && needRemoveAnnualPlan) {
    const currentSaasPlanList = _.filter(currentPlanList, p => p.isSaas);
    const needFilterCategories = _.chain(currentSaasPlanList)
      .groupBy('category')
      .omitBy((categoryList) => _.some(categoryList, (p) => p.cycleValue <= currentBasePlan.cycleValue))
      .keys()
      .value();

    logger.info('with bought monthly base plan, should filter only annual plan list, filter categories:', needFilterCategories);

    return _.filter(planList, (p) => ($context.is.edit && p.cartInfo.selected_number > 0) || !_.includes(needFilterCategories, p.category));
  }

  return planList;
};
